module.exports = __webpack_public_path__ + "static/media/BasierCircle-Medium.7d3b41f2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Medium.woff
// module id = 6542
// module chunks = 1